'use strict'

export const sidenavigation = (() => {
    const init = () => {
        const sidenavigationToggle = document.querySelector('#sidenavigation-toggle')
        const sidenavigation = document.querySelector('#sidenavigation')
        const moduleContent = document.querySelector('#module-content')

        if (sidenavigationToggle && sidenavigation && moduleContent) {
            sidenavigationToggle.addEventListener('click', () => {
                sidenavigation.classList.add('activated')
                moduleContent.classList.add('activated')

                sidenavigation.classList.toggle('active')
                sidenavigationToggle.classList.toggle('active')
                moduleContent.classList.toggle('active')

                if (sidenavigation.classList.contains('active')) {
                    sessionStorage.setItem('sidenavigationIsOpen', 'true')
                } else {
                    sessionStorage.setItem('sidenavigationIsOpen', 'false')
                }
            })

            const checkSidenavigationState = () => {
                const sidenavigationIsOpen = sessionStorage.getItem('sidenavigationIsOpen')

                if (sidenavigationIsOpen === 'true' || !sidenavigationIsOpen) {
                    sidenavigation.classList.toggle('active')
                    sidenavigationToggle.classList.toggle('active')
                    moduleContent.classList.toggle('active')
                }
            }

            checkSidenavigationState()
        }
    }

    return {
        init
    }
})()
